export const LIST_REVIEW = 'LIST_REVIEW';
export const CREATE_REVIEW = 'CREATE_REVIEW';
export const DETAIL_REVIEW = 'DETAIL_REVIEW';
export const UPDATE_REVIEW = 'UPDATE_REVIEW';
export const DELETE_REVIEW = 'DELETE_REVIEW';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';